import { setUser } from "@sentry/react";
import { useTranslation } from "react-i18next";

import { PortalHeading } from "@/components/Portal/components/PortalHeading/PortalHeading";
import { useGetCustomer } from "@/services/api";

/** The cockpit greeting - "Hi <first name>!" and nothing else, per design. */
export const WelcomeText = () => {
  const { t } = useTranslation("portal");

  const { data: customer, isLoading: customerIsLoading } = useGetCustomer(
    undefined,
    {
      query: {
        onSuccess: (data) => {
          setUser({ id: data?.id?.toString() });
        },
        // Safe to cache for 5 minutes, as the name will never change.
        staleTime: 5 * 60 * 1000,
      },
    },
  );

  const customerName = customer?.firstName || "User";

  return (
    <PortalHeading
      isLoading={customerIsLoading}
      variant="cockpit"
      heading={t("cockpit.heading.greeting", { name: customerName })}
    />
  );
};
